module.exports = __webpack_public_path__ + "img/bottom.1e889574.png";